import moment from 'moment';

import { Reason } from '@/types/reason';
import { getMinimalCharLength } from '@utils/config';
import mainTheme from '@styled/themes/mainTheme';

import { EXPIRED, EXPIRED_VERIFYING, REDEEMED, REQUESTED } from '@utils/promotions';

import { Order } from '@/types/order';

export const REASON_DEFAULT = 0;
export const RADIX_TEN = 10;
export const EXPIRED_REASON_KEY = 5;
export const OTHER_REASON_KEY = 0;
export const MIN_REASON_LENGTH = getMinimalCharLength();

export const LABEL_COUPON_ALERT = 6;

export const CANCELLATION_REASONS: Reason[] = [
  {
    value: 1,
    label: 'pages.coupons.cancel.notFoundOption',
  },
  {
    value: 2,
    label: 'pages.coupons.cancel.forgotOption',
  },
  {
    value: 3,
    label: 'pages.coupons.cancel.dontWantOption',
  },
  {
    value: 4,
    label: 'pages.coupons.cancel.couponNotWorking',
  },
  {
    value: 5,
    label: 'pages.coupons.cancel.expired',
  },
  {
    value: 0,
    label: 'pages.coupons.cancel.otherReasons',
  },
];

export const CANCELLATION_WITHDRAWAL_REASONS: Reason[] = [
  {
    value: 1,
    label: 'pages.coupons.cancel.withDrawal.noStockOption',
  },
  {
    value: 2,
    label: 'pages.coupons.cancel.withDrawal.notWorkingOption',
  },
  {
    value: 3,
    label: 'pages.coupons.cancel.withDrawal.dontWantOption',
  },
  {
    value: 4,
    label: 'pages.coupons.cancel.withDrawal.noTimeOption',
  },
  {
    value: 0,
    label: 'pages.coupons.cancel.withDrawal.otherReasons',
  },
];

export const getBorderColor = (status: string) => {
  switch (status) {
    case REQUESTED: {
      return mainTheme.colors.secondary;
    }
    case REDEEMED: {
      return mainTheme.colors.primary_lighter;
    }
    case EXPIRED:
    case EXPIRED_VERIFYING: {
      return mainTheme.colors.danger;
    }
    default:
      return mainTheme.colors.white;
  }
};

export const calculateDaysUntilCouponExpires = (order: Order) => {
  const today = moment(new Date());
  const date = moment(order?.expirationDate);

  date.format('DD MMMM YYYY');
  today.format('DD MMMM YYYY');

  return date.diff(today, 'days') ?? null;
};

export enum WhereToShow {
  Detail = 'detail',
  SideList = 'side',
  EvaluationList = 'eval',
}
